<template>
  <div class="nav-left" :style="{height: height + 'px'}">
    <el-menu class="el-menu-vertical-demo left-bar" ref="menu"
             :unique-opened="true" :collapse="isCollapse" :default-openeds="activeMenu"
             :default-active="activeApp">
      <!--
      <div @click="changeMode" class="change-mode pointer">
        <icon name="riv-tick"></icon>
      </div>
      -->
      <el-submenu v-for="(area, index) in menu" :key="index" :index="area.area" :class="[(activeMenu.indexOf(area.area) >= 0) ? 'is-active-custom' : '']">
        <!-- MENU GRANDE -->
        <template slot="title" v-if="!isCollapse">
          <div class="titolo" @click="goToDashboard(area)">
            <icon :name="($t(area.area).icon)" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']" :style="[isTitleVisible ? {} : {'display': 'none'}]"></icon>
            <div :style="[isTitleVisible ? {} : {'display': 'none'}]" slot="title" class="my-label">{{ $t(area.area).label.toUpperCase() }}</div>
          </div>
        </template>
        <!-- MENU PICCOLO -->
        <template slot="title" v-else>
          <div class="titolo" @click="goToDashboard(area)">
            <icon :name="($t(area.area).icon)" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']"></icon>
          </div>
        </template>

        <el-menu-item class="intestazione-area" :index="area.area">
          <div class="label-area" @click="goToDashboard(area)">
            {{ $t(area.area).label.toUpperCase() }}
          </div>
        </el-menu-item>
        <el-menu-item v-for="(item, index) in area.apps" :key="index" :index="item.codiApp" @click="goToApp($t(item.codiApp).path, item.codiApp, area.area)">
          <div class="label-menu">
            <icon name="riv-circle_2" scale="0.5"></icon>
            <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ $t(item.codiApp).label }}</div>
          </div>
        </el-menu-item>

        <!--
        <el-submenu index="1-4" v-if="area.area === 'UFFACQ' && menuPatch.length > 0">
          <div slot="title" class="sub-titolo">
            <icon name="riv-circle_2" scale="0.5"></icon>
            <div class="titolo">
              Gestione Appalti
            </div>
          </div>

          <el-menu-item v-for="(item, index) in menuPatch" :key="index" :index="item.codiApp" @click="goToApp($t(item.codiApp).path, item.codiApp, 'UFFACQ')">
            <div class="label-menu">
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ $t(item.codiApp).label }}</div>
            </div>
          </el-menu-item>

        </el-submenu>
        -->

      </el-submenu>
    </el-menu>
    <div class="servizi">
      <div class="linea"></div>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.contattaci.contattaci')" placement="top">
        <div class="servizio pointer">
          <icon name="riv-contacts" scale="1.6"
                @click.native="goToContattaci"></icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.lingua.cambioLingua')" placement="top">
        <div class="servizio pointer">
          <icon name="riv-world" scale="1.6"
                @click.native="(lingua.languageDialogVisible = !lingua.languageDialogVisible)"></icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.bottoni.logout')" placement="top">
        <div class="servizio pointer">
          <icon name="riv-uscitaStab" scale="1.6"
                @click.native="logout"></icon>
        </div>
      </el-tooltip>
    </div>

    <el-dialog class="modal-contattaci" :title="$t('navLeft.contattaci.contattaci').toUpperCase()" :visible.sync="contattaci.contattiDialogVisible"
               :append-to-body="true"
               custom-class="custom-dialog offset-xl-6 col-xl-12 offset-lg-5 col-lg-14 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">
      <div v-loading="contattaci.loading">
        <div class="row row-custom">
          <div class="elemento col-12 no-padding">
            <span class="my-label">
              {{ $t('navLeft.contattaci.areeDiLavoro') }}
            </span>
            <el-select v-model="contattaci.areaLavoro" value-key="area" @change="changeAreaLavoro" class="custom-select-el">
              <el-option v-for="item in contattaci.areeDiLavoro" :key="item.area" :label="$t(item.area + '.label')" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="elemento offset-1 col-11 no-padding">
            <span class="my-label col-24 no-padding">
              {{ $t('navLeft.contattaci.stato') }}
            </span>
            <el-select v-model="contattaci.countryContatti" @change="changeCountryContatti" class="custom-select-el">
              <el-option :label="$t('navLeft.contattaci.stati')[1]" :value="1"></el-option>
              <el-option :label="$t('navLeft.contattaci.stati')[2]" :value="2"></el-option>
              <el-option :label="$t('navLeft.contattaci.stati')[3]" :value="3"></el-option>
              <el-option :label="$t('navLeft.contattaci.stati')[4]" :value="4"></el-option>
              <el-option :label="$t('navLeft.contattaci.stati')[5]" :value="5"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row row-custom">
          <div class="col-sinistra col-12 no-padding">
            <div class="elemento">
              <span class="my-label">
                {{ $t('navLeft.contattaci.a') }}
              </span>
              <el-select v-model="contattaci.contatto" value-key="codContatto" class="custom-select-el">
                <el-option v-for="item in contattaci.contatti" :key="item.codContatto" :label="item.nome"
                           :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="elemento">
              <span class="my-label">
                {{ $t('navLeft.contattaci.oggetto') + ' (*)' }}
              </span>
              <el-input placeholder="" v-model="contattaci.oggettoMsg" class="custom-input"></el-input>
            </div>
            <div class="elemento">
              <span class="my-label">
                {{ $t('navLeft.contattaci.messaggio') + ' (*)' }}
              </span>
              <el-input type="textarea" resize="none"
                :autosize="{minRows: 3, maxRows: 6}"
                placeholder="" v-model="contattaci.msg"
              ></el-input>
            </div>
          </div>

          <div class="col-destra offset-1 col-11 no-padding">
            <div class="dati-contatto col-24 no-padding">
              <div class="dato row row-custom" v-if="(contattaci.contatto.mail !== '')">
                <div class="dato-label col-4 no-padding">
                  <icon name="riv-mail" scale="1"></icon>
                </div>
                <div class="dato-value col-20 no-padding">
                  {{ contattaci.contatto.mail }}
                </div>
              </div>
              <div class="dato row row-custom" v-if="(contattaci.contatto.tel !== '')">
                <div class="dato-label col-4 no-padding">
                  <icon name="riv-phone2" scale="1"></icon>
                </div>
                <div class="dato-value col-20 no-padding">
                  {{ contattaci.contatto.tel }}
                </div>
              </div>
              <div class="dato row row-custom" v-if="(contattaci.contatto.fax !== '')">
                <div class="dato-label col-4 no-padding">
                  <icon name="riv-print" scale="1"></icon>
                </div>
                <div class="dato-value col-20 no-padding">
                  {{ contattaci.contatto.fax }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="elemento col-24 no-padding">
          <span class="my-label">
            {{ $t('navLeft.contattaci.allegato') }}
          </span>
          <br>
          <el-upload
            class="upload-demo" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
            :on-change="changeUploadList"
            action="" :limit="1"
            :auto-upload="false" :file-list="contattaci.uploadList" ref="upload">
            <el-button size="mini" class="custom-button">
              {{ $t('navLeft.contattaci.scegli') }}
            </el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button @click="inviaMsg" :disabled="checkInvioMsg" class="custom-button" type="primary">
            {{ $t('navLeft.contattaci.invia').toUpperCase() }}
          </el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog class="modal-lingua" :title="$t('navLeft.lingua.cambioLingua').toUpperCase()"
               :visible.sync="lingua.languageDialogVisible" :append-to-body="true"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">
      <div style="height: auto">
        <div class="elemento">
          <span class="my-label">{{ $t('navLeft.lingua.linguaImpostata') + ': '}}</span>
          <span><b>&emsp;{{$t('navLeft.lingua')[codLang]}}</b></span>
        </div>
        <div class="elemento">
          <span class="my-label">{{ $t('navLeft.lingua.cambioLingua') }}</span>
          <div class="radio row row-custom">
            <el-radio v-model="lingua.lingua" label="it_IT" class="col-6 no-padding custom-radio"
                      v-if="codLang !== 'it_IT'"><!--{{$t('navLeft.lingua.it_IT')}}-->Italiano
            </el-radio>
            <el-radio v-model="lingua.lingua" label="fr_FR" class="col-6 no-padding custom-radio"
                      v-if="codLang !== 'fr_FR'"><!--{{$t('navLeft.lingua.fr_FR')}}-->Français
            </el-radio>
            <el-radio v-model="lingua.lingua" label="es_ES" class="col-6 no-padding custom-radio"
                      v-if="codLang !== 'es_ES'"><!--{{$t('navLeft.lingua.es_ES')}}-->Español
            </el-radio>
            <el-radio v-model="lingua.lingua" label="de_DE" class="col-6 no-padding custom-radio"
                      v-if="codLang !== 'de_DE'"><!--{{$t('navLeft.lingua.de_DE')}}-->Deutsch
            </el-radio>
            <el-radio v-model="lingua.lingua" label="en_GB" class="col-6 no-padding custom-radio"
                      v-if="codLang !== 'en_GB'"><!--{{$t('navLeft.lingua.en_GB')}}-->English
            </el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button @click="setLanguage" class="custom-button" type="primary"
                     :disabled="(lingua === '')">{{ $t('navLeft.lingua.imposta').toUpperCase() }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { bus } from './Bus'

export default {
  name: 'NavLeft',
  props: {
    height: {
      type: Number,
      required: true,
      default: 650
    }
  },
  i18n: {
    messages: {
      it_IT: {
        navLeft: {
          contattaci: {
            contattaci: 'Contattaci',
            a: 'A',
            areeDiLavoro: 'Aree di Lavoro',
            oggetto: 'Oggetto',
            messaggio: 'Messaggio',
            allegato: 'Allegato',
            scegli: 'Scegli...',
            invia: 'Invia',
            stato: 'Stato',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'Spagna',
              4: 'Belgio',
              5: 'Germania'
            }
          },
          lingua: {
            it_IT: 'ITALIANO',
            fr_FR: 'FRANCESE',
            es_ES: 'SPAGNOLO',
            de_DE: 'TEDESCO',
            en_GB: 'INGLESE',
            cambioLingua: 'Cambio lingua',
            linguaImpostata: 'Lingua impostata',
            imposta: 'Imposta'
          },
          bottoni: {
            logout: 'Logout'
          },
          invioMsgOK: 'Invio effettuato correttamente',
          invioMsgKO: 'Invio fallito'
        }
      },
      fr_FR: {
        navLeft: {
          contattaci: {
            contattaci: 'Contactez-nous',
            a: 'À',
            areeDiLavoro: 'Champ d\'Application',
            oggetto: 'Sujet',
            messaggio: 'Message',
            allegato: 'Enceinte',
            scegli: 'Choisir...',
            invia: 'Soumettre',
            stato: 'Nation',
            stati: {
              1: 'Italie',
              2: 'France',
              3: 'Espagne',
              4: 'Belgique',
              5: 'Allemagne'
            }
          },
          lingua: {
            it_IT: 'ITALIEN',
            fr_FR: 'FRANÇAIS',
            es_ES: 'ESPAGNOL',
            de_DE: 'ALLEMAND',
            en_GB: 'ANGLAIS',
            cambioLingua: 'Changer la langue',
            linguaImpostata: 'Langue choisie',
            imposta: 'Configurer'
          },
          bottoni: {
            logout: 'Logout'
          },
          invioMsgOK: 'Envoi réussi',
          invioMsgKO: 'Envoi échoué'
        }
      },
      es_ES: {
        navLeft: {
          contattaci: {
            contattaci: 'Contáctenos',
            a: 'Para',
            areeDiLavoro: 'Área de Aplicación',
            oggetto: 'Objeto',
            messaggio: 'Mensaje',
            allegato: 'Anexo',
            scegli: 'Elegir...',
            invia: 'Enviar',
            stato: 'País',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'España',
              4: 'Bélgica',
              5: 'Alemania'
            }
          },
          lingua: {
            it_IT: 'ITALIANO',
            fr_FR: 'FRANCÉS',
            es_ES: 'ESPAÑOL',
            de_DE: 'GERMAN',
            en_GB: 'INGLÉS',
            cambioLingua: 'Cambiar el idioma',
            linguaImpostata: 'Idioma elegido'
          },
          bottoni: {
            logout: 'Logout'
          },
          invioMsgOK: 'Envío exitoso',
          invioMsgKO: 'Envío fallido'
        }
      },
      de_DE: {
        navLeft: {
          contattaci: {
            contattaci: 'Kontaktieren Sie uns',
            a: 'Empfänger',
            areeDiLavoro: 'Anwendungsbereich',
            oggetto: 'Betreff',
            messaggio: 'Nachricht',
            allegato: 'Anhang',
            scegli: 'Wählen...',
            invia: 'Absenden',
            stato: 'Land',
            stati: {
              1: 'Italien',
              2: 'Frankreich',
              3: 'Spanien',
              4: 'Belgien',
              5: 'Deutschland'
            }
          },
          lingua: {
            it_IT: 'ITALIAN',
            fr_FR: 'FRENCH',
            es_ES: 'SPANISCHE',
            de_DE: 'DEUTSCH',
            en_GB: 'ENGLISCH',
            cambioLingua: 'Ändere die Sprache',
            linguaImpostata: 'Gewählte Sprache'
          },
          bottoni: {
            logout: 'Logout'
          },
          invioMsgOK: 'Versand erfolgreich',
          invioMsgKO: 'Senden fehlgeschlagen'
        }
      },
      en_GB: {
        navLeft: {
          contattaci: {
            contattaci: 'Contact us',
            a: 'To',
            areeDiLavoro: 'Application Area',
            oggetto: 'Subject',
            messaggio: 'Message',
            allegato: 'Attached',
            scegli: 'Choose...',
            invia: 'Send',
            stato: 'Country',
            stati: {
              1: 'Italy',
              2: 'France',
              3: 'Spain',
              4: 'Belgium',
              5: 'Germany'
            }
          },
          lingua: {
            it_IT: 'ITALIAN',
            fr_FR: 'FRENCH',
            es_ES: 'SPANISH',
            de_DE: 'GERMAN',
            en_GB: 'ENGLISH',
            cambioLingua: 'Change language',
            linguaImpostata: 'Selected language',
            imposta: 'Select'
          },
          bottoni: {
            logout: 'Logout'
          },
          invioMsgOK: 'Sending successful',
          invioMsgKO: 'Sending failed'
        }
      }
    }
  },
  data () {
    return {
      menu: [],
      // Patch manuale per il secondo livello di menù (Gestione Appalti)
      // menuPatch: [],
      isCollapse: true,
      activeMenu: [],
      activeApp: '',
      codLang: '',
      isTitleVisible: true,
      contattaci: {
        contattiDialogVisible: false,
        areeDiLavoro: [],
        areaLavoro: '',
        contatti: [],
        contatto: {},
        countryContatti: 1,
        oggettoMsg: '',
        msg: '',
        uploadList: [],
        loading: false
      },
      lingua: {
        languageDialogVisible: false,
        lingua: ''
      },
      isIE10: false
    }
  },
  computed: {
    checkInvioMsg: function () {
      return !(this.contattaci.oggettoMsg !== '' && this.contattaci.msg !== '')
    }
  },
  mounted: function () {
    bus.$on('changeActiveApp', (activeApp, area) => {
      this.$set(this, 'activeApp', activeApp)
      this.$set(this, 'activeMenu', [area])
    })

    let ua = window.navigator.userAgent
    let msie = ua.indexOf('MSIE ')
    this.$set(this, 'isIE10', (msie > 0))
    if (sessionStorage.hasOwnProperty('codLang')) {
      this.$root.$i18n.locale = sessionStorage.getItem('codLang')
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
    } else {
      sessionStorage.setItem('codLang', 'it_IT')
      this.$root.$i18n.locale = 'it_IT'
      this.$set(this, 'codLang', 'it_IT')
    }
    this.getMenu()
  },
  methods: {
    logout: function () {
      sessionStorage.setItem('token', '')
      sessionStorage.removeItem('token')
      sessionStorage.clear()
      this.$store.commit('reset')
      this.$router.push({ name: 'Login' })
    },
    changeCountryContatti: function () {
      this.$set(this.contattaci, 'loading', true)
      this.$set(this.contattaci, 'contatto', {})
      this.getContatti()
    },
    changeAreaLavoro: function () {
      this.$set(this.contattaci, 'loading', true)
      this.$set(this.contattaci, 'contatto', {})
      this.getContatti()
    },
    changeUploadList: function (file, fileList) {
      this.$set(this.contattaci, 'uploadList', fileList)
    },
    inviaMsg: function () {
      let formData = new FormData()
      formData.append('country', this.contattaci.countryContatti)
      formData.append('area', this.contattaci.areaLavoro.area)
      formData.append('codContatto', this.contattaci.contatto.codContatto)
      formData.append('oggetto', this.contattaci.oggettoMsg)
      formData.append('msg', this.contattaci.msg)
      console.log(this.contattaci.uploadList)
      for (let i = 0; i < this.contattaci.uploadList.length; i++) {
        let file = this.contattaci.uploadList[i]
        formData.append('file', file.raw)
      }
      this.$http.post('portale/contattaci', formData, {
        params: {
          codLang: this.codLang
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this.contattaci, 'contattiDialogVisible', false)
            this.$set(this.contattaci, 'uploadList', [])
            this.$set(this.contattaci, 'oggettoMsg', '')
            this.$set(this.contattaci, 'msg', '')
            this.$message({
              showClose: true,
              message: this.$t('navLeft.invioMsgOK'),
              type: 'success',
              duration: process.env.duration
            })
          } else {
            if (response.body.msg) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            } else {
              this.$message({
                showClose: true,
                message: this.$t('navLeft.invioMsgKO'),
                type: 'error',
                duration: process.env.duration
              })
            }
          }
          this.$set(this.contattaci, 'uploadList', [])
          this.$refs.upload.clearFiles()
        })
    },
    goToContattaci: function () {
      this.$set(this.contattaci, 'contattiDialogVisible', true)
      this.$set(this.contattaci, 'loading', true)
      if (sessionStorage.hasOwnProperty('areeLavoro')) {
        this.$set(this.contattaci, 'areeDiLavoro', JSON.parse(sessionStorage.getItem('areeLavoro')))
        this.$set(this.contattaci, 'areaLavoro', this.contattaci.areeDiLavoro[0])
        this.getContatti()
      }
    },
    getContatti: function () {
      this.$http.get('portale/contatti', {
        params: {
          codLang: this.codLang,
          area: this.contattaci.areaLavoro.area,
          country: this.contattaci.countryContatti
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this.contattaci, 'contatti', response.body.data)
            if (response.body.data.length > 0) {
              this.$set(this.contattaci, 'contatto', response.body.data[0])
            }
          } else {
            this.$set(this.contattaci, 'contatti', [])
            this.$set(this.contattaci, 'contatto', {})
            this.$message({
              showClose: true,
              message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          setTimeout(() => {
            this.$set(this.contattaci, 'loading', false)
          }, 300)
        })
    },
    setLanguage: function () {
      this.$set(this, 'codLang', this.lingua.lingua)
      sessionStorage.setItem('codLang', this.lingua.lingua)
      this.$root.$i18n.locale = this.lingua.lingua
      this.$set(this.lingua, 'languageDialogVisible', false)
      bus.$emit('changeLanguage')
    },
    changeMode: function () {
      this.$set(this, 'isTitleVisible', !this.isTitleVisible)
      setTimeout(() => {
        this.$set(this, 'isCollapse', !this.isCollapse)
        this.$emit('changeMenuMode', this.isCollapse)
      }, 50)
    },
    goToDashboard: function (area) {
      // if (area.area !== 'ACCSTA') {
        this.$set(this, 'activeMenu', [area.area])
        this.$set(this, 'activeApp', '')
        if (this.$route.name !== area.area) {
          this.$router.push({ name: area.area })
        }
      //}
    },
    goToApp: function (appPath, appName, area) {
      this.$set(this, 'activeMenu', [area])
      this.$set(this, 'activeApp', appName)
      this.$router.push(appPath)
      this.$emit('closeMessages')
    },
    getMenu: function () {
      this.$http.get('portale/menu', {
        params: {
          codLang: this.codLang
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let menuData = response.body.data

            /*
            // INIZIO Patch per il secondo livello di menu
            let menuDataPatch = response.body.data
            let appsAcqNew = []
            let appsAcqPatch = []

            for (let j = 0; j < menuDataPatch.length; j++) {
              let obj = menuDataPatch[j]
              if (obj.area === 'UFFACQ') {
                obj.apps.forEach(app => {
                  if (app.codiApp !== 'WebAnagraficaDip' && app.codiApp !== 'WebDocRichiesti') {
                    appsAcqNew.push(app)
                  } else {
                    if (app.codiApp === 'WebDocRichiesti') {
                      appsAcqPatch.splice(0, 0, app)
                    } else {
                      appsAcqPatch.push(app)
                    }
                  }
                })
                menuData[j].apps = appsAcqNew
              }
            }
            this.$set(this, 'menuPatch', appsAcqPatch)
            // FINE Patch
            */

            // INIZIO Patch ordinamento aree
            let menuDataPatch = response.body.data
            let index = -1
            menuDataPatch.forEach((area, i) => {
              if (area.area === 'ACCSTA') {
                index = i
              }
            })

            if (index >= 0) {
              let area = menuDataPatch.splice(index, 1)[0]
              // INIZIO Patch WebAssociaDip
              let appsPatch = area.apps
              let indexApps = -1
              appsPatch.forEach((codiApp, i) => {
                if (codiApp.codiApp === 'WebAssociaDip') {
                  indexApps = i
                }
              })

              if (indexApps >= 0) {
                let apps = appsPatch.splice(indexApps, 1)[0]
                appsPatch.unshift(apps)
              }
              // FINE Patch WebAssociaDip

              menuDataPatch.push(area)
              menuData = menuDataPatch
            }
            // FINE Patch

            this.$set(this, 'menu', menuData)
            let arrayAree = []
            for (let i = 0; i < response.body.data.length; i++) {
              let obj = {
                area: response.body.data[i].area,
                apps: response.body.data[i].apps
              }
              arrayAree.push(obj)
            }
            sessionStorage.setItem('areeLavoro', JSON.stringify(arrayAree))

            if (this.$route.path === '/') {
              this.$set(this, 'activeMenu', [response.body.data[0].area])
              this.$router.push({ name: response.body.data[0].area })
            } else {
              let tree = this.$route.matched
              if (tree !== undefined) {
                let area = (tree[1] !== undefined) ? tree[1].meta.area : ''
                let appName = (tree[2] !== undefined) ? tree[2].meta.appName : ''

                this.$set(this, 'activeMenu', [area])
                this.$set(this, 'activeApp', appName)
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../assets/less/general.less";

  .modal-contattaci {
    .elemento {
      .set-font(@size: 14px, @family: 'os-regular', @color: @greenRiva);
      margin-top: 5px;
      margin-bottom: 20px;
      .radio {
        margin-top: 10px;
        color: #007c74;
      }
      .value {
        color: #bbbbbb;
      }
      .el-textarea__inner {
        .set-font(@size: 14px, @color: @grayMedium);
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 0;
      }
      .el-textarea__inner:focus {
        border: 1px solid #007c74;
      }
      .el-input {
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          height: 22px;
          padding-left: 0;
          line-height: 0;
          .set-font(@size: 14px, @color: @grayMedium);
        }
      }
      .upload-demo {
        .el-upload {
          .el-upload__input {
            display: none !important;
          }
        }
      }
    }
    .col-destra {
      border: 1px solid #e7e7e7;
      margin-top: 11px;
      height: 216px;
      .header-contatto {
        height: 50px;
        background-color: @greenRiva;
        color: @white;
        .icona {
          line-height: 50px;
          padding-top: 7px;
        }
        .nome {
          line-height: 50px;
        }
      }
      .dati-contatto {
        .dato {
          color: @greenRiva;
          margin-top: 20px;
          .dato-label {
            text-align: center;
            padding-top: 0;
          }
        }
      }
    }
  }

  .modal-lingua {
    .elemento {
      .set-font(@size: 14px);
      margin-top: 5px;
      margin-bottom: 20px;
      .my-label {
        color: @greenRiva;
      }
      .radio {
        margin-top: 10px;
        color: @greenRiva;
      }
      .value {
        color: #bbbbbb;
      }
    }
  }

  .nav-left {
    .servizi {
      z-index: 100;
      color: @white;
      position: absolute;
      bottom: 0;
      padding-bottom: 15px;
      width: 55px;
      text-align: center;
      // border-top: 1px solid @white;
      // padding-top: 10px;
      box-shadow: inset 0px 3px 10px #454848;
      -webkit-box-shadow: inset 0px 3px 10px #454848;
      -moz-box-shadow: inset 0px 3px 10px #454848;
      -o-box-shadow: inset 0px 3px 10px #454848;
      .linea {
        width: 45px;
        height: 1px;
        background-color: @white;
        margin-left: 5px;
        margin-bottom: 30px;
      }
      .servizio {
        margin-top: 20px;
      }
    }
    // Menu generale (e grande)
    .el-menu {
      width: 132px;
      border-right: 1px solid #eef4f9;
    }
    .left-bar {
      .change-mode {
        color: @white;
        height: 53px;
        line-height: 53px;
      }
      z-index: 10;
      width: 131px;
      box-shadow: inset -6px 4px 5px #454848;
      -webkit-box-shadow: inset -6px 4px 5px #454848;
      -moz-box-shadow: inset -6px 4px 5px #454848;
      -o-box-shadow: inset -6px 4px 5px #454848;
      float: left;
      background-color: @greenRiva;
      color: @white;
      text-align: center;
      padding-top: 53px;
      padding-left: 0 !important;
      border-right: 0;
      .titolo {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        font-family: 'os-semibold';
        text-align: center;
        padding-top: 13px;
        padding-bottom: 7px;
        border-bottom: 1px solid #eef4f9;
        height: 100%;
        .icon {
          right: 15px;
          margin: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ie10 {
          height: 30px;
        }
        .my-label {
          margin-top: 5px;
          word-wrap:  break-word;
          width: 90px;
          white-space:  normal;
          line-height: 13px;
          font-size: 12px;
        }
      }
      a {
        color: @white;
      }
      .label-menu {
        width: 90%;
        word-wrap: break-word;
        border-left: 2px solid @white;
        margin-left: 10px;
        padding-left: 15px;
        height: 100%;
        .set-font(@size: 13px; @color: @white);
        vertical-align: middle;
        line-height: 18px;
        padding-top: 13px;
        text-align: left;
        display: inline-block;
      }
      .cerchio {
        margin-left: -26px;
        width: 20px;
        height: 20px;
        float: left;
      }
      .applicazione {
        float: left;
        width: 72px;
      }
      .el-submenu__icon-arrow {
        display: none;
      }
      .el-submenu__title {
        height: 120px;
        line-height: 38px;
        color: @white;
        margin-top: -3px;
        .my-label {
          width: 100%;
        }
      }
      .el-submenu__title:hover {
        color: @greenRiva !important;
        background-color: #e6fbfa;
      }
      .is-opened {
        .label {
          color: @greenRiva;
        }
        .el-submenu__title {
          color: @greenRiva !important;
          box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
          -webkit-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
          -moz-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
          -o-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
          z-index: 10;
        }
        background-color: #eef4f9;
      }
      .el-menu-item {
        box-shadow: inset -10px 0 6px -4px #454848;
        -webkit-box-shadow: inset -10px 0 6px -4px #454848;
        -moz-box-shadow: inset -10px 0 6px -4px #454848;
        -o-box-shadow: inset -10px 0 6px -4px #454848;
        min-width: 0;
        max-width: 100%;
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
        text-align: center;
        overflow: hidden;
        background-color: @greenRiva;
        color: @white;
        height: 63px;
        white-space: pre-wrap;
      }
      .label-menu {
        .applicazione {
          .set-font(@family: 'os-regular'; @color: #dcd9d9; @size: 13px);
          &.selected-app {
            .set-font(@family: 'os-semibold'; @color: @white; @size: 13px);
          }
        }
      }
    }
    .el-menu-vertical-demo {
      min-height: 100%;
    }

    // Menu piccolo
    .el-menu--collapse {
      &.left-bar {
        width: 55px;
        padding-top: 28px;
        .el-submenu {
          margin-bottom: 10px;
          .el-submenu__title {
            height: 55px;
            padding: 0 !important;
            .titolo {
              padding-top: 10px;
              border-bottom: 0;
            }
          }
          &.is-active-custom {
            background-color: #eef4f9;
            .el-submenu__title {
              color: @greenRiva;
              box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
              -webkit-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
              -moz-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
              -o-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
              z-index: 10;
              &.is-opened {
                box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
                -webkit-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
                -moz-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
                -o-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
              }
            }
          }
          &.is-opened {
            background-color: #e6fbfa;
          }
        }
      }
    }
  }

  .el-menu--vertical {
    .el-menu {
      background-color: #e6fbfa;
      margin-left: 0;
      box-shadow: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      -o-box-shadow: none;
    }
    .el-menu-item:hover {
      .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
      background-color: #e6fbfa;
    }
    .el-menu-item {
      .label-menu {
        display: flex;
        .fa-icon {
          line-height: 35px;
          height: 35px;
          margin-right: 10px;
          color: #bbb;
        }
      }
      .set-font(@family: 'os-regular', @color: @textTable, @size: 12px);
      letter-spacing: 1px;
      text-transform: uppercase;
      height: 35px;
      line-height: 35px;
      .selected-app {
        .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
      }
      &.intestazione-area {
        .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 15px);
        height: 25px;
        line-height: 25px;
        margin-bottom: 5px;
      }
    }
    .el-submenu {
      .el-submenu__title {
        .set-font(@family: 'os-regular', @color: @textTable, @size: 12px);
        letter-spacing: 1px;
        text-transform: uppercase;
        height: 35px;
        line-height: 35px;
        .sub-titolo {
          display: flex;
          .fa-icon {
            line-height: 35px;
            height: 35px;
            margin-right: 10px;
            color: #bbb;
          }
          .titolo {
            margin-right: 15px;
          }
        }
      }
      .el-submenu__title:hover {
        // .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
        background-color: #e6fbfa;
      }
      .el-menu-item {
        text-transform: capitalize;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavLeft.vue